module.exports = __webpack_public_path__ + "media/images/version_merge/qr_code/preview-d6ca85c5285c17266b748d12c82dfff1.png";